import React from 'react';

const SessionContext = React.createContext({
  userSession: null,
  setUserSession: () => { }
});

export default SessionContext;
